"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var validator = function textInputControlValidator(state, props) {
  var storedValue = state.storedValue; // Validates 01-12/XX

  var defaultPattern = /^(0[0-9]|1[0-2])\/\d{2}$/g;
  return new RegExp(props.fieldData.validation.pattern || defaultPattern).test(storedValue);
};

var _default = validator;
exports["default"] = _default;